import { PURCHASE_FLOW_ROUTE, POLICY_DOWNLOAD_FLOW_ROUTE } from '@/shared/constants/flow.constants'
import type { useFlowResult } from './useFlow.types'
import { type RouteLocationNormalizedLoaded, useRoute } from 'vue-router'
import { VisitorsDirection } from '@/shared/types/other.types'
import type { AvailableFlowRoutes } from '@/shared/types/flow.types'

export const useFlow = (
  routeIfCallNotFromSetupFunction?: RouteLocationNormalizedLoaded
): useFlowResult => {
  // useRouter() can only be called from the `setup` function inside the component, if you call it from elsewhere (from store or hooks) it will return `undefined`. This is why it sometimes necessary to manually pass the `route`. '

  // Function argument specifically has an unusal name as `routeIfCallNotFromSetupFunction`, to understand why we need this, because it is a hack.

  const route = routeIfCallNotFromSetupFunction ?? useRoute()

  let flowDirection: VisitorsDirection
  let flowScheme: AvailableFlowRoutes[]

  if (!route) {
    console.error(
      'Route is undefined. Call useFlow() insude of `setup` function or pass route instance manually.'
    )
    flowDirection = VisitorsDirection.UNKNOWN
    flowScheme = []
  } else {
    const hasPurchaseFlow = !!route?.matched?.find((r) => r.name === VisitorsDirection.PURCHASE)
    const hasPolicyDownloadFlow = !!route?.matched?.find((r) => r.name === VisitorsDirection.POLICY_DOWNLOAD)

    if (hasPurchaseFlow) {
      flowDirection = VisitorsDirection.PURCHASE
      flowScheme = PURCHASE_FLOW_ROUTE
    } else if (hasPolicyDownloadFlow) {
      flowDirection = VisitorsDirection.POLICY_DOWNLOAD
      flowScheme = POLICY_DOWNLOAD_FLOW_ROUTE
    } else {
      flowDirection = VisitorsDirection.UNKNOWN
      flowScheme = []
    }
  }

  return {
    flowScheme,
    flowDirection
  }
}